// extracted by mini-css-extract-plugin
export default {"loaderMain":"loader_loaderMain__DaQZ0"};